import { DatePipe } from '@angular/common';
import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { AssinaturaService, GlobalService, Login } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GrdEmpenhoExtra } from './grd-empenho-extra';

import * as toastr from 'toastr';
import { EmpenhoExtraService } from '../service/empenho-extra.service';

@Component({
  selector: 'app-grd-empenho-extra-dlg',
  templateUrl: './grd-empenho-extra-dlg.component.html'
})
export class GrdEmpenhoExtraDlgComponent implements OnInit, OnDestroy {

  protected datepipe: DatePipe;
  public ptBR: any;
  public selectedOrdem: string;
  public selectedOpt: string;
  public selectNaoImpresso: boolean;
  public selectUsuario: boolean;
  public dataInicio: Date;
  public dataFinal: Date;
  public numeroInicio: number;
  public numeroFinal: number;
  protected unsubscribe: Subject<void> = new Subject();

  public imaskNumero = {
    mask: Number,
    scale: 0,
    signed: false
  };

  @Input() login: Login;

  constructor(
    protected messageService: MessageService,
    protected injector: Injector,
    private globalService: GlobalService,
    protected assinaturaService: AssinaturaService,
    private empenhoExtraService: EmpenhoExtraService,
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.datepipe = new DatePipe('pt');
    this.selectedOrdem = 'ord1';
    this.selectedOpt = 'opt1';
    this.selectNaoImpresso = false;
    this.selectUsuario = false;
    this.dataInicio = new Date();
    this.dataFinal = new Date();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  async imprimir() {
    const parametros = {};
    let relations = 'contrato,favorecido';
    parametros['relations'] = relations;
    parametros['exercicio_id'] = this.login.exercicio.id;
    parametros['orgao_id'] = this.login.orgao.id;

    if (this.selectedOpt === 'opt1') {
      if (!this.dataFinal || !this.dataFinal) {
        toastr.warning('Informe a data inicial e final');
        return
      } else {
        parametros['data_empenho$ge'] = this.datepipe.transform(this.dataInicio, 'yyyy-MM-dd');
        parametros['data_empenho$le'] = this.datepipe.transform(this.dataFinal, 'yyyy-MM-dd');
      }
    } else {
      if (!this.numeroInicio && !this.numeroFinal) {
        toastr.warning("Informe o numero final e inicial");
        return
      } 
      if ((this.numeroInicio && !this.numeroFinal) || (!this.numeroInicio && this.numeroFinal)) {
        this.numeroInicio ? parametros['numero'] = this.numeroInicio : parametros['numero'] = this.numeroFinal
      } else {
        parametros['numero$ge'] = this.numeroInicio;
        parametros['numero$le'] = this.numeroFinal;
      }
    }
    parametros['orderBy'] = this.selectedOrdem === 'ord1' ? 'data_empenho' : 'numero';
    if (this.selectNaoImpresso) {
      parametros['impresso'] = !this.selectNaoImpresso;
    }
    if (this.selectUsuario) {
      parametros['usuario_cadastro_id'] = this.login.usuario.id;
    }

    this.empenhoExtraService
      .extendido(1, -1, parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(lista => {
        const param = {};
        param['exercicio_id'] = this.login.exercicio.id;
        param['orgao.id'] = this.login.orgao.id;
        new GrdEmpenhoExtra(this.injector).imprimir(lista.content, this.login);
      },
        (error) => this.messageService.add(
          { severity: 'error', summary: 'Atenção!', detail: error.error && error.error.payload ? error.error.payload : error }
        )
      );      
  }

}
